import { Paper, Grid, Typography, Stack, Button } from "@mui/material"
import { ChargeCategory } from "../../Objects/ChargeCategory"

export interface ChargeCategoryItemProps {
    chargeCategory: ChargeCategory,
    onDelete: (chargeCategory: ChargeCategory) => void
    onEdit: (chargeCategory: ChargeCategory) => void
}
export function ChargeCategoryItem({
    chargeCategory,
    onDelete,
    onEdit,
}: ChargeCategoryItemProps): JSX.Element {

    let number = "";
    if (chargeCategory.min_number && chargeCategory.min_number === chargeCategory.max_number) {
        number = `${chargeCategory.min_number}人`
    } else {
        if (chargeCategory.min_number) {
            number += `${chargeCategory.min_number}人以上`
        }
        if (chargeCategory.max_number) {
            number += `${chargeCategory.max_number}人以下`
        }
    }
    let rvtiming = ""
    if (chargeCategory.rvtiming_start && chargeCategory.rvtiming_start === chargeCategory.rvtiming_end) {
        rvtiming = `${chargeCategory.rvtiming_start}日前`
    } else {
        if (chargeCategory.rvtiming_start) {
            rvtiming += `${chargeCategory.rvtiming_start}日前以降`
        }
        if (chargeCategory.rvtiming_end) {
            rvtiming += `${chargeCategory.rvtiming_end}日前まで`
        }
    }

    return (
        <Paper
            variant="outlined"
            key={chargeCategory.chrcate_id}
        >
            <Grid container
                p={1}
                spacing={1}
            >
                <Grid item xs={12}>
                    <Typography
                        variant="h6"
                        component={"p"}
                    >{chargeCategory.chrcate_name}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography>下記を満たす {chargeCategory.member ? "会員" : "非会員"} の予約に適用</Typography>
                    {(number !== "") &&
                        <Typography variant="body2">・人数が {number} の場合</Typography>
                    }
                    {(rvtiming !== "") &&
                        <Typography variant="body2">・予約タイミングが {rvtiming} の場合</Typography>
                    }
                    {(chargeCategory.max_unit) &&
                        <Typography variant="body2">・予約コマ数が {chargeCategory.max_unit}コマ以下 の場合</Typography>
                    }
                </Grid>
                <Grid item xs={12}>
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                    >
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                onDelete(chargeCategory)
                            }}
                        >削除</Button>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                onEdit(chargeCategory)
                            }}
                        >編集</Button>
                    </Stack>
                </Grid>
            </Grid>
        </Paper>

    )
}